/*
 * DRV ønskeliste — simpel, indbygget favorit-funktion.
 * Gemmer produkt-id'er i browserens localStorage (ingen app, ingen konto nødvendig).
 */
(function () {
  var KEY = 'drv_wishlist';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }

  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }

  function sync(btn) {
    var id = btn.getAttribute('data-product-id');
    var active = read().indexOf(id) > -1;
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.setAttribute('title', active ? 'Fjern fra ønskeliste' : 'Gem til ønskeliste');
  }

  function toggle(btn) {
    var id = btn.getAttribute('data-product-id');
    var list = read();
    var i = list.indexOf(id);
    if (i > -1) { list.splice(i, 1); } else { list.push(id); }
    write(list);
    sync(btn);
  }

  function init() {
    var buttons = document.querySelectorAll('[data-drv-wishlist]');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      if (btn.dataset.drvBound) continue;
      btn.dataset.drvBound = '1';
      sync(btn);
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        toggle(this);
      });
    }
  }

  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }

  // Kør igen efter variant-/section-opdateringer (Shopify udsender disse events).
  document.addEventListener('shopify:section:load', init);
})();
